import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Menu = () => {
  const [toggle, setToggle] = useState(false);
  const [showDrop, setShowDrop] = useState(false);

  const toggleMenu = () => {
    setToggle(!toggle);
  };

  const showDropdown = () => {
    setShowDrop(!showDrop);
  };
  return (
    <div className="navbar-collapse d-flex align-items-center py-1">
      <ul className="d-flex align-items-center navbar-nav ml-auto">
        <div
          className={`d-flex align-items-center ${
            toggle ? "menu-show" : "menu-hide"
          }`}>
          <li className="nav-item">
            <NavLink activeClassName="activeMenu" exact className="text-white font-weight-bolder" to="/">
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink activeClassName="activeMenu" exact className="text-white font-weight-bolder" to="/about">
              About
            </NavLink>
          </li>
          <li className="nav-item">
            <a
              onClick={toggleMenu}
              className="text-white font-weight-bolder"
              href="/#how-it-works">
              How it works
            </a>
          </li>
          <li className="nav-item">
            <NavLink activeClassName="activeMenu" exact className="text-white font-weight-bolder" to="/blog">
              Blog
            </NavLink>
          </li>
          <li className="nav-item position-relative">
            <button
              onClick={showDropdown}
              className="primary-btn lemon-btn px-1 py-50">
              REGISTER
            </button>
            <div className={`menu-dropdown ${showDrop ? "d-block" : "d-none"}`}>
              <NavLink activeClassName="activeMenu" exact
                to="/employer/signup"
                className="d-inline-block text-black px-1 py-50 font-weight-bolder">
                Employers
              </NavLink>
              <NavLink activeClassName="activeMenu" exact
                to="/developer/signup"
                className="d-inline-block text-black border-top px-1 py-50 font-weight-bolder">
                Developers
              </NavLink>
            </div>
          </li>
          <li className="nav-item">
            <NavLink activeClassName="activeMenu" exact
              to="/login"
              className="secondary-btn px-1 py-50 text-white font-weight-bolder">
              Log in
            </NavLink>
          </li>
        </div>
        <div className="font-medium text-center hamburger" onClick={toggleMenu}>
          {toggle ? (
            <i class="fas fa-times text-white"></i>
          ) : (
            <i class="fas fa-bars text-white"></i>
          )}
        </div>
      </ul>
    </div>
  );
};

export default Menu;
